import React from 'react';
import PropTypes from 'prop-types';
import TimeRangePicker from '@wojtekmaj/react-timerange-picker';

import './SensorSelector.css';

export default function SensorSelector({
  date, request, setRequestValue, title,
}) {
  const { maxTime, minTime, thingName = '' } = request || {};
  const times = [minTime || '13:00', maxTime || '21:00'];
  const label = ((date > '2024-11-18') && thingName.includes('h3po-hrm-argos')) ? 'Sensors' : title;
  return (
    <div className="thing-name-selector-container">
      <span className="thing-name-selector-label">{label}</span>
      <div>
        <TimeRangePicker
          disableClock
          format="HH:mm"
          clockIcon={null}
          onChange={([selMinTime, selMaxTime]) => setRequestValue(({
            ...request,
            minTime: selMinTime,
            maxTime: selMaxTime,
          }))}
          value={times}
        />
        <span>UTC</span>
      </div>
    </div>
  );
}

SensorSelector.propTypes = {
  date: PropTypes.string.isRequired,
  request: PropTypes.any.isRequired,
  setRequestValue: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
